import { inputAnatomy } from '@chakra-ui/anatomy'
import { mode } from '@chakra-ui/theme-tools'
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/styled-system'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys)

const size = {
  xs: defineStyle({
    borderRadius: 'input.xs',
    textStyle: 'xs',
  }),
  sm: defineStyle({
    borderRadius: 'input.sm',
    textStyle: 'sm',
  }),
  md: defineStyle({
    borderRadius: 'input.md',
    textStyle: 'md',
  }),
  lg: defineStyle({
    borderRadius: 'input.lg',
    textStyle: 'lg',
  }),
}

const sizes = {
  xs: definePartsStyle({
    addon: size.xs,
    element: size.xs,
    field: size.xs,
  }),
  sm: definePartsStyle({
    addon: size.sm,
    element: size.sm,
    field: size.sm,
  }),
  md: definePartsStyle({
    addon: size.md,
    element: size.md,
    field: size.md,
  }),
  lg: definePartsStyle({
    addon: size.lg,
    element: size.lg,
    field: size.lg,
  }),
}

const variantOutline = definePartsStyle({
  // Just define one colorScheme for now. If more come,
  // We need to implement colorSchemes for inputs in this file.
  field: {
    bg: 'input.background',
    borderColor: 'input.border',
    _placeholder: { opacity: 1, color: 'input.placeholder' },
    _hover: {
      borderColor: 'input.hover.border',
    },
  },
})

const variants = {
  outline: variantOutline,
}

export const Input = defineMultiStyleConfig({
  sizes,
  variants,
  defaultProps: {
    variant: 'outline',
  },
})
